import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-back-button',
  standalone: false,
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.css'],
})
export class BackButtonComponent implements OnInit {
  //emitir evento ao clicar no botão
  @Output() back = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  emitBack() {
    this.back.emit();
  }
}
